const faqs = [
  {
    q: '吃瓜网每日大赛的消息来源可靠吗？',
    a: '我们拥有一支专业的娱乐采编团队，每条爆料都会经过至少三个独立信源的交叉验证后才发布。对无法确认的信息，我们会明确标注"待核实"，绝不传播未经证实的谣言。',
  },
  {
    q: '如何第一时间收到最新的吃瓜推送？',
    a: '将吃瓜网每日大赛添加到浏览器收藏夹，或关注我们的微信公众号和小程序。我们每天早上8点、中午12点、晚上8点三个时段进行重点内容推送，重大爆料随时更新。',
  },
  {
    q: '可以在吃瓜网投稿爆料吗？',
    a: '当然可以！我们非常欢迎广大网友提供第一手爆料线索。你可以通过页面上的投稿通道发送邮件或微信联系我们，所有投稿人信息将严格保密，经核实后的爆料会标注来源发布。',
  },
  {
    q: '吃瓜网的内容更新频率是怎样的？',
    a: '我们是7×24小时全天候更新的娱乐八卦平台。工作日日均更新超过200条内容，周末和节假日也不停更。重大热点事件发生时，我们会在15分钟内完成信息核实并发布。',
  },
  {
    q: '吃瓜网的评论区为什么看起来不像实时的？',
    a: '为了维护良好的社区讨论氛围，所有评论在发布前都会经过审核。我们展示的是经过筛选的优质评论，虽然看起来不像实时滚动，但每一条都是有价值的瓜友真实观点。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="bg-background-100 py-16 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4">
              常见问题
            </span>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
              常见问题
            </h2>
            <p className="text-foreground-600 text-sm">
              关于吃瓜网每日大赛，你可能想了解的几个问题
            </p>
          </div>

          <div className="space-y-3">
            {faqs.map((faq) => (
              <details
                key={faq.q}
                className="group rounded-xl bg-background-50 border border-background-200/70 overflow-hidden"
              >
                <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
                  <h3 className="font-semibold text-sm md:text-base text-foreground-900 pr-4">
                    {faq.q}
                  </h3>
                  <div className="flex-shrink-0 w-7 h-7 flex items-center justify-center rounded-lg bg-background-100 text-foreground-500 group-open:bg-primary-500 group-open:text-white transition-colors">
                    <i className="ri-add-line text-sm group-open:hidden"></i>
                    <i className="ri-subtract-line text-sm hidden group-open:block"></i>
                  </div>
                </summary>
                <div className="px-5 pb-5 -mt-1">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.a}
                  </p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}